import { defineTokens } from './schema';

/** The default Bloomience token set. Values equal the `--bl-*` values `@bloom/ui` shipped with. */
export const bloomienceTokens = defineTokens({
  name: 'bloomience',
  direction: 'rtl',
  color: {
    light: {
      canvas: '#f4f6f5',
      surface: '#ffffff',
      surfaceMuted: '#f0f3f2',
      line: '#e1e6e4',
      lineStrong: '#c9d1ce',
      ink: '#15201c',
      inkMuted: '#56645f',
      inkSubtle: '#65726d',
      primary: '#17785c',
      primaryHover: '#11614a',
      primarySoft: '#e2f1eb',
      onPrimary: '#ffffff',
      accent: '#b8860b',
      accentSoft: '#fbf1d6',
      danger: '#c23b34',
      dangerSoft: '#fbe7e5',
      warning: '#955f08',
      warningSoft: '#fcf0d9',
      success: '#1b7549',
      successSoft: '#e1f3e8',
      info: '#2c68a8',
      infoSoft: '#e3edf8',
      sidebar: '#0f1f1a',
      sidebarInk: '#a9bcb4',
      sidebarInkStrong: '#f1f6f3',
      sidebarActive: '#1b3a30',
      sidebarLine: '#1f332c',
      chart1: '#17785c',
      chart2: '#b8860b',
      chart3: '#2c68a8',
      overlay: 'rgb(8 17 14 / 0.45)',
      shadowOverlay: '0 16px 40px -12px rgb(15 31 26 / 0.22), 0 2px 6px rgb(15 31 26 / 0.06)',
    },
    dark: {
      canvas: '#0b1411',
      surface: '#111c18',
      surfaceMuted: '#16231e',
      line: '#22332c',
      lineStrong: '#30453c',
      ink: '#e4ece8',
      inkMuted: '#a4b3ad',
      inkSubtle: '#83938d',
      primary: '#3fb38c',
      primaryHover: '#5cc59f',
      primarySoft: '#16372c',
      onPrimary: '#06120e',
      accent: '#e7b540',
      accentSoft: '#3a2f12',
      danger: '#ef6f66',
      dangerSoft: '#3a1916',
      warning: '#e0a33a',
      warningSoft: '#3a2a10',
      success: '#4cc085',
      successSoft: '#143222',
      info: '#6ea8e5',
      infoSoft: '#13283d',
      sidebar: '#07100d',
      // Not overridden in dark before the move: same as light.
      sidebarInk: '#a9bcb4',
      sidebarInkStrong: '#f1f6f3',
      sidebarActive: '#16302a',
      sidebarLine: '#16261f',
      chart1: '#3fb38c',
      chart2: '#e7b540',
      chart3: '#6ea8e5',
      overlay: 'rgb(0 0 0 / 0.6)',
      shadowOverlay: '0 16px 40px -12px rgb(0 0 0 / 0.6), 0 2px 6px rgb(0 0 0 / 0.3)',
    },
  },
  font: { arabic: 'IBM Plex Sans Arabic', latin: 'IBM Plex Sans' },
  // px; the web theme maps these to the rem values in styles.css (12/13/15/18/22/28).
  size: { xs: 12, sm: 13, md: 15, lg: 18, xl: 22, '2xl': 28 },
  lineHeight: { tight: 1.25, normal: 1.5 },
  radius: { sm: 6, md: 8, lg: 12, xl: 16, full: 999 },
  space: [4, 8, 12, 16, 24, 32, 48, 64],
});
